<template>
  <main class="home-page" :style="getBackgroundImg">
    <header class="header">
      <LibraryLogo/>
      <div class="entrance">
        <router-link class="url" :to="{ name: 'logIn' }">
          <img src="@/assets/images/user_blue_icon.svg" alt="user icon">
          <span class="text">{{$t('SIGN_IN')}}</span>
        </router-link>
      </div>
    </header>
    <router-view></router-view>
    <div class="bottom-banner" v-if="bannerText" v-html="bannerText"/>
  </main>
</template>

<script>
import LibraryLogo from '@/components/library-logo'
import { mapState } from 'vuex'
import { decodeJWT } from '@/utilityFunctions'

export default {
  name: 'library-landing-page',
  components: { LibraryLogo },
  data () {
    return {
      LoginPopupOpened: false
    }
  },
  mounted () {
    this.checkIfUserConected()
  },
  computed: {
    ...mapState({
      backgroundImg: state => state.base.library?.metadata.landingpage_img,
      bannerText: state => state.base.library?.metadata.banner_text
    }),
    getBackgroundImg () {
      return `background-image: url(${this.backgroundImg})`
    }
  },
  beforeCreate () {
    localStorage.removeItem('collectionEntry')
    if (this.$route.query.collectionEntry) {
      localStorage.setItem('collectionEntry', this.$route.query.collectionEntry)
    }
  },
  methods: {
    checkIfUserConected () {
      if (localStorage.getItem('jwt')) {
        const jwt = decodeJWT(localStorage.getItem('jwt'))
        if (!jwt.uuid) { return }
        const self = this
        this.$store.dispatch('goCollectionEntryDirect').then(function (res) {
          if (res) return
          self.$router.push({ name: 'baseLibrary' })
        })
      }
    }
  }
}
</script>
<style lang="scss">
.bottom-banner{
  position: fixed; bottom: 0; inset-inline: 0; background-color: rgba(255, 255, 255, 0.9); min-height: 30px;
  text-align: center; color: #000; line-height: 1.2; font-size: 12px; width: 100%;
  padding-block: 7px; padding-inline: 5px;
  *{
    font-size: inherit;
  }
}
</style>
<style lang="scss" scoped>
  body, html {
    height: 100%;
    margin: 0;
  }
</style>
